/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const HeadphonesIconOutline = createIcon({
  displayName: 'HeadphonesIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19,17h-1c-0.552,0 -1,-0.448 -1,-1v-5c0,-0.552 0.448,-1 1,-1h1c1.105,0 2,0.895 2,2v3c0,1.105 -0.895,2 -2,2Z"></path>
        <path d="M6,17h-1c-1.105,0 -2,-0.895 -2,-2v-3c0,-1.105 0.895,-2 2,-2h1c0.552,0 1,0.448 1,1v5c0,0.552 -0.448,1 -1,1Z"></path>
        <path d="M18.5,10v-0.5c0,-3.59 -2.91,-6.5 -6.5,-6.5v0c-3.59,0 -6.5,2.91 -6.5,6.5v0.5"></path>
        <path d="M12.625,21.25h-1.25c-0.69,0 -1.25,-0.56 -1.25,-1.25v0c0,-0.69 0.56,-1.25 1.25,-1.25h1.25c0.69,0 1.25,0.56 1.25,1.25v0c0,0.69 -0.56,1.25 -1.25,1.25Z"></path>
        <path d="M13.875,20h2.125c1.105,0 2,-0.895 2,-2v-1"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const HeadphonesIconTwoTone = createIcon({
  displayName: 'HeadphonesIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="twoToneStrokeColor" fill="twoToneFillColor" strokeLinejoin="round">
        <path d="M19,17h-1c-0.552,0 -1,-0.448 -1,-1v-5c0,-0.552 0.448,-1 1,-1h1c1.105,0 2,0.895 2,2v3c0,1.105 -0.895,2 -2,2Z"></path>
        <path d="M6,17h-1c-1.105,0 -2,-0.895 -2,-2v-3c0,-1.105 0.895,-2 2,-2h1c0.552,0 1,0.448 1,1v5c0,0.552 -0.448,1 -1,1Z"></path>
        <path fill="none" d="M18.5,10v-0.5c0,-3.59 -2.91,-6.5 -6.5,-6.5v0c-3.59,0 -6.5,2.91 -6.5,6.5v0.5"></path>
        <path d="M12.625,21.25h-1.25c-0.69,0 -1.25,-0.56 -1.25,-1.25v0c0,-0.69 0.56,-1.25 1.25,-1.25h1.25c0.69,0 1.25,0.56 1.25,1.25v0c0,0.69 -0.56,1.25 -1.25,1.25Z"></path>
        <path fill="none" d="M13.875,20h2.125c1.105,0 2,-0.895 2,-2v-1"></path>
      </Box>
      <Box as="path" xmlns="http://www.w3.org/2000/svg" fill="none" d="M0,0h24v24h-24Z" />
    </>
  ),
})

const HeadHeadphoness: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={HeadphonesIconTwoTone} {...props} />
    default:
      return <CustomIcon as={HeadphonesIconOutline} {...props} />
  }
}

export default memo(HeadHeadphoness)
